import NextImage from 'next/image';
import { Text } from '../../Text/Text';
import styles from '../PostImageGridItem.module.css';

import { Post } from '../../PostsViewer/types/Post';
import { openPostViewerEventSources } from '../../PostsViewer/types/openPostViewerEventSources';
import { getTextExcerpt } from '../../../helpers/strings/getTextExcerpt';

export interface IImageGridPostProps {
  post: Post;
  openPostViewer: (postId?: string, eventSource?: openPostViewerEventSources) => Promise<void>;
}

export const PostImageGridItem = ({ post, openPostViewer }: IImageGridPostProps) => {
  const { _id, displayEntity, text, images } = post;
  const imageSrc = images.edges?.[0]?.node?.url;
  const imageWidth = images.edges?.[0]?.node?.width;
  const imageHeight = images.edges?.[0]?.node?.height;

  return (
    <button
      className="bg-trench relative"
      style={{ minHeight: 'min-content' }}
      onClick={() => void openPostViewer(_id, openPostViewerEventSources.BrandsGrid)}
    >
      {imageSrc && (
        <NextImage
          src={imageSrc}
          width={imageWidth}
          height={imageHeight}
          alt={`Post by ${displayEntity?.displayName}`}
          className="relative block size-full object-fill"
        />
      )}
      <div
        className={`${styles.overlay} group absolute bottom-0 left-0 size-full overflow-hidden transition-all`}
      >
        <div className="absolute bottom-0 flex h-1/2 w-full items-end justify-start p-6 opacity-0 group-hover:translate-y-0 group-hover:opacity-100">
          <div className="flex items-center space-x-2">
            {displayEntity?.displayIcon.url && (
              <NextImage
                src={displayEntity.displayIcon.url}
                width={displayEntity.displayIcon.width}
                height={displayEntity.displayIcon.height}
                alt={displayEntity.displayName}
                className="size-8 rounded-full"
                unoptimized
              />
            )}
            <div>
              <div className="text-sm font-semibold text-white md:text-base">
                {displayEntity?.displayName}
              </div>
              <Text variant="sm" className="text-white">
                {getTextExcerpt(text.text ?? '')}
              </Text>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
};
